var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcPaymentClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427320996"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2828",
    cx: 12,
    cy: 12.9863,
    r: 12,
    fill: "#3C6FF5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.28595 12.9865H12H16.714",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcPaymentClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_payment_close.36bf01ae45c55ddf958a8d51611ca421.svg";